import { Methods } from '@newview/infrastructure';
import {BasicDataBaseApi} from "./BasicDataBaseApi";


export class MessageApi extends BasicDataBaseApi {

    public get ControllerName(): any {
        return 'message';
    }

    /**
     * 分页获取消息
     * @param params
     */
    public getMessageByPage(flag,userId,current,size){
        return this.send({flag:flag,userId: userId,current:current,size:size},"getMessageByPage",Methods.GET);
    }

     /**
     * 消息已读接口
     * @param params 
     * @returns 
     */
    public readMessageIds(params){
       return this.send(params,"readMessageIds",Methods.GET);
    }
    /**
     * 获取用户待处理消息，不含流程消息
     * @param userId 
     * @returns 
     */
    public getMessageByUserId(userId){
        return this.send({userId: userId},"getMessageByUserId",Methods.GET);
    }

}